export const DRAWER_ANIMATION_MS = 100;
